import request from './request';

// 获取举报原因
export function getReason() {
  return request('/report/reasons', {
    method: 'GET'
  });
}
// 举报
export function tipoff(params) {
  return request('/report', {
    method: 'POST',
    params,
  });
}